import { DownloadFileLinkField } from 'domain/shared/artifact/field';
import { PoliciesDataType } from 'domain/shared/compliance';
import { BadgeField, FieldProps } from 'framework/ui/field';
import { Badge } from 'framework/ui/mui-builder';
import { useListContext } from 'framework/list';
import { useShowContext } from 'framework/show';
import { useDispatch, useSelector } from 'react-redux';
import { setNotificationResponse } from 'infrastructure/notification/redux/actions';
import { NOTIFICATIONS_TYPES } from 'infrastructure/notification/constants';
import { selectPolicyNotifications } from 'domain/people/employee/compliance/shared/notifications/selectPolicyNotifications';
import {
  isComplianceRegistryItemNotSigned,
  isComplianceRegistryItemViewed,
  isRegistryItemNew,
} from 'domain/people/employee/compliance/shared/complianceRegistryPortalRules';
import { PortalComplianceDataType } from '../types';

const notSignedBadge = (
  <Badge
    id="not-signed"
    color="error"
    isVisible={(policy: PoliciesDataType) => isComplianceRegistryItemNotSigned(policy)}
  >
    Not signed
  </Badge>
);

const newBadge = (
  <Badge id="new" color="success" isVisible={(policy: PoliciesDataType) => isRegistryItemNew(policy)}>
    New
  </Badge>
);

const EmployeePortalComplianceNameField = (props: FieldProps) => {
  const { data } = useShowContext();
  const { setData } = useListContext();
  const dispatch = useDispatch();
  const complianceNotifications = useSelector(selectPolicyNotifications);

  const portalData = data?.getData();

  const handlePreviewClose = () => {
    if (!portalData?.policyPath || isComplianceRegistryItemViewed(portalData as unknown as PoliciesDataType)) {
      return;
    }

    setData?.((prev: { items?: PortalComplianceDataType[] }) => {
      const updatedItems = (prev?.items || []).map((item): PortalComplianceDataType => {
        if (item.portalRowId !== portalData.portalRowId) {
          return item;
        }

        return {
          ...item,
          isViewed: true,
        };
      });

      return {
        ...prev,
        items: updatedItems,
      };
    });

    dispatch(
      setNotificationResponse({
        type: NOTIFICATIONS_TYPES.POLICY,
        response: complianceNotifications || [],
      }),
    );
  };

  return (
    <BadgeField {...props} label="Name" source="policyPath" badges={[notSignedBadge, newBadge]}>
      <DownloadFileLinkField
        showNameSource="complianceName"
        source="policyPath"
        pathSource="policyPath"
        onPreviewClose={handlePreviewClose}
      />
    </BadgeField>
  );
};

export default EmployeePortalComplianceNameField;
